import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-icon-expand',
    templateUrl: './icon-expand.component.html',
    styleUrls: ['./icon-expand.component.scss']
})
export class IconExpandComponent implements OnInit {

    @Input() cssClass = '';
    @Input() isExpanded: boolean = false;

    constructor() { }

    ngOnInit() {
    }

}
